import WelcomeMessage from './WelcomeMessage/WelcomeMessage'
import useHome from './useHome'
import useHomeStyles from './useHomeStyles'
import SpeedFormation from './SpeedFormation/SpeedFormation'
import { Gamification } from './Gamification'
import { Card, FlexContainer, Header1 } from '@/shared/theme/styled-components'

const Home = () => {
  const { data, isLoading, isExternal, t } = useHome()
  const { child } = useHomeStyles()

  if (isLoading || !data) {
    return (
      <Card>
        <p>{t('common:fetching_data')}</p>
      </Card>
    )
  }

  return (
    <>
      <FlexContainer id='home-welcome'>
        <Card className={child}>
          <Header1>{t('home:home_welcome')}</Header1>
          <WelcomeMessage />
        </Card>
        {!isExternal && (
          <Card className={child}>
            <Header1>{t('home:speed_formation.title')}</Header1>
            <SpeedFormation />
          </Card>
        )}
      </FlexContainer>
      <Gamification />
    </>
  )
}

export default Home
